import { INDEX_NAMES } from 'shared/blocks/header/components/components/SearchEngine/constants';
export const isFAQIndex = (indexName: string) =>
  INDEX_NAMES.includes(indexName);
